<template>
  <div id="box">
    <div class="inner">
      <h1 v-html="$t('qrCodeAuthorization.title')" />
      <div class="tabWrappers">
        <Tab :tabType="'email'" :isSelected="false" @tab="toSelectEmailPage" />
        <Tab :tabType="'qrcode'" :isSelected="true" />
      </div>
      <div class="scrollWrapper">
        <p v-html="$t('qrCodeAuthorization.description')" class="description" />
        <div class="expandWrapper">
          <QRCode />
        </div>
      </div>
      <div class="wrapper">
        <div class="checkboxWrapper">
          <input
            type="checkbox"
            id="qrcodeChecked"
            name="qrcode"
            v-model="qrcodeChecked"
            v-on:change="onQrcodeChange(qrcodeChecked)"
          />
          <label
            for="qrcodeChecked"
            class="checkbox"
            v-html="$t('qrCodeAuthorization.checkbox')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "../components/qrCode.vue";
import Tab from "../components/tab.vue";

export default {
  name: "QRCodeAuthorization",
  components: {
    QRCode,
    Tab,
  },
  data() {
    return {
      qrcodeChecked: true,
    };
  },
  methods: {
    toSelectEmailPage() {
      this.$emit("clearStatusTimer");
      this.$emit("navigate", { page: "SelectEmail", errorType: "" });
    },
    onQrcodeChange() {
      this.setAuthType();
    },
    setAuthType() {
      localStorage.setItem("isDefaultQRCode", this.qrcodeChecked);
    },
  },
  mounted() {
    this.$emit("qrCodeAuthorization");
    this.isDefaultQRCode = JSON.parse(localStorage.getItem("isDefaultQRCode"));
    switch (this.isDefaultQRCode) {
      case null:
        this.setAuthType();
        break;
      default:
        this.qrcodeChecked = this.isDefaultQRCode;
        break;
    }
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper
    +flex()
  .description
    margin-bottom: 0
  .wrapper
    margin-top: 12px
    .checkboxWrapper
      margin-top: 12px
      input[type=checkbox]
        display: none
      .checkbox
        box-sizing: border-box
        cursor: pointer
        display: inline-block
        padding: 8px 32px
        position: relative
        width: auto
        &:before
          +size(18px, 18px, 3px)
          +abpos(4px, initial, 50%, initial)
          background-color: $gs1
          border: 2px solid $gs4
          content: ''
          display: block
          margin-top: -8px
        &:after
          +size(18px, 18px)
          content: url('../assets/imgs/checked.svg')
          display: block
          +abpos(4px, initial, 7px, initial)
          opacity: 0
      input[type=checkbox]:checked + .checkbox
        &:before
          background-color: $color1
        &:after
          opacity: 1
</style>
